import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { faqs } from '@/mocks/manga';

export default function FaqPreview() {
  const items = faqs.slice(0, 3);
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <SectionTitle
              kicker="常见问题"
              title="追漫前的疑惑，这里先解答"
              desc="关于题材、角色、感情线与剧情走向的常见疑问，帮你快速入门这部作品。"
            />
            <div className="mt-6 space-y-3">
              {items.map((f) => (
                <details key={f.q} className="group rounded-lg bg-background-100 p-4">
                  <summary className="flex cursor-pointer items-center justify-between gap-3 text-sm font-medium text-foreground-900">
                    {f.q}
                    <i className="ri-add-line text-lg text-foreground-500 transition-transform group-open:rotate-45"></i>
                  </summary>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </details>
              ))}
            </div>
            <Link
              to="/faq"
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600"
            >
              查看更多常见问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-col justify-center rounded-lg bg-primary-900 p-8 md:p-10">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-200">
              <i className="ri-magic-line"></i>
              快速入门
            </span>
            <h3 className="mt-3 font-heading text-2xl text-background-50 md:text-3xl">
              想一眼看懂这部作品？
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-background-200">
              从剧情主线到人物关系再到分集要点，我们已经帮你全部梳理好。只需花几分钟，就能带着清晰的期待开始追漫。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/plot"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
              >
                阅读剧情主线
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                关于本站
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}